import { sendAnalyticsEvent } from '~/lib/analytics.client';
import { AnalyticsAction, AnalyticsTrackEvent } from '~/types/analytics';

export function trackVersionHistoryPanelOpened() {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryPanelOpened,
    },
  });
}

export function trackVersionHistorySnapshotPreviewedFromChat(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistorySnapshotPreviewedFromChat,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistorySnapshotPreviewedFromHistoryPanel(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistorySnapshotPreviewedFromHistoryPanel,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryPreviewExited(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryPreviewExited,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryBookmarkAdded(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryBookmarkAdded,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryBookmarkRemoved(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryBookmarkRemoved,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistorySnapshotRenamed(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistorySnapshotRenamed,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryRestoreModalOpened(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryRestoreModalOpened,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryRestoreModalCancelled(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryRestoreModalCancelled,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryRestoreStarted(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryRestoreStarted,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryRestoreSucceeded(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryRestoreSucceeded,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryRestoreFailed(messageId: string) {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryRestoreFailed,
      properties: {
        message_id: messageId,
      },
    },
  });
}

export function trackVersionHistoryHelpButtonClicked() {
  sendAnalyticsEvent({
    action: AnalyticsAction.Track,
    payload: {
      event: AnalyticsTrackEvent.VersionHistoryHelpButtonClicked,
    },
  });
}
